export const isUuid = (value: unknown): value is string => {
  return typeof value === 'string' && value.length === 36;
};
